import { SpinLoaderDirective } from '@myre/ui-primitive-components';
import { TranslatePipe } from '@myre/ui-primitive-core';
import { FormComponent, QuestionHidden } from '@myre/ui-primitive-forms';

import { AsyncPipe } from '@angular/common';
import { Component, type OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { of, type Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ModalSectionKey } from '../../../modal.interface';

import { ModalSectionComponent } from '../abstract/modal-section.component';

@Component({
  selector: 'myre-modal-body-default',
  templateUrl: './app-modal-body-default.component.html',
  styleUrls: ['./app-modal-body-default.component.scss'],
  imports: [
    SpinLoaderDirective,
    FormsModule,
    FormComponent,
    ReactiveFormsModule,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class DefaultBodyComponent
  extends ModalSectionComponent
  implements OnInit
{
  protected _name = ModalSectionKey.Body;

  public isLoading$: Observable<boolean> = of(false);
  public hasVisibleElement$: Observable<boolean> = of(false);

  public ngOnInit(): void {
    if (this.modalRef()) {
      this.hasVisibleElement$ = this._context().elements.pipe(
        filter(Boolean),
        map(elements => {
          return elements.some(
            e =>
              !(e instanceof QuestionHidden) &&
              (e.enabled || e.keepOnDisabled) &&
              e.visible,
          );
        }),
      );
    }
  }
}
